import React from "react";
import { Box, CssBaseline } from "@mui/material";
import LoginLogo from "./LoginLogo";

const Layout = ({ children }) => (
  <>
    <CssBaseline />
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: 2, sm: 4 },
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          justifyContent: "center",
          gap: { xs: 4, sm: 6, md: 8 },
          width: "100%",
          maxWidth: 1200,
          minWidth: 1200,
          border: "1px solid #B7C9DD",
          p: 0,
          boxSizing: "border-box",
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            flex: "0 0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: "-110px",
            marginTop: "-1px",
          }}
        >
          <LoginLogo />
        </Box>

        {/* Form content */}
        <Box
          sx={{
            flex: "0 0 auto",
            width: "100%",
            maxWidth: 380,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box sx={{ width: "100%" }}>{children}</Box>
        </Box>
      </Box>
    </Box>
  </>
);

export default Layout;
